<template>
  <div class="audi-answer">
    <div class="audi-answer__sub-title">
      <h4>Le financement adapté à vos besoins</h4>
    </div>

    <div class="audi-answer__container">
      <h3>{{ userSolution.title }}</h3>
      <p>{{ userSolution.details }}</p>
      <div class="audi-answer__links-container">
        <a
          v-for="(link, index) in userSolution.links"
          :key="index"
          :href="link.src"
          :class="[index ? 'audi-btn-white' : 'audi-btn-black']"
          target="_blank"
        >
          {{ link.text }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AudiAnswer',
  props: {
    userSolution: {
      type: Object,
      required: true,
    }
  }
}
</script>

<style lang="scss">
.audi-answer {
  position: relative;
  height: 100%;
  width: 80%;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 4rem;

  @media (min-width: 1200px) {
    gap: 8rem;
  }

  &__sub-title {
    font-family: AudiTypeExtended;
    font-size: var(--sub-paragraph);
    margin-top: 52px;
    
    > h4 {
      font-size: var(--sub-paragraph);
    }
  }

  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media (min-width: 320px) {
      gap: 3rem;
    }

    > h3 {
      font-family: AudiTypeExtended;
      font-size: var(--sub-title);
      font-weight: 700;
      max-width: 400px;
      line-height: 5rem;
    }

    > p {
      font-family: AudiTypeWide;
      font-size: var(--sub-paragraph);
      letter-spacing: -0.4px;
      font-style: normal;
      font-weight: 400;
      line-height: 3rem;
      margin: 0;
    }
  }

  &__links-container {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
}
</style>